import { render, staticRenderFns } from "./NotificationCardForPathActivityComment.vue?vue&type=template&id=920349aa&scoped=true&"
import script from "./NotificationCardForPathActivityComment.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForPathActivityComment.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForPathActivityComment.vue?vue&type=style&index=0&id=920349aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920349aa",
  null
  
)

export default component.exports